import { RootState } from '../../../rootReducer';

export const selectConnectorIdBySlug = (slug: string) => (state: RootState): string => {
  return state.dashboard.connectorIdSlugMap.data[slug];
};
